import * as type from '../actions/types';

const initialState = {
  revenueAnalytics: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  performanceComparison: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  popularItems: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  popularItemsSummary: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  orderChannelMix: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  revenueTrendHourly: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  revenueTrendHourlyComparison: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  revenueTrendHourlyBand: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  revenueTrendDayBand: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_REVENUE_ANALYTICS_PENDING:
      return {
        ...state,
        revenueAnalytics: {
          ...state.revenueAnalytics,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_REVENUE_ANALYTICS_SUCCESS:
      return {
        ...state,
        revenueAnalytics: {
          ...state.revenueAnalytics,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_REVENUE_ANALYTICS_FAILURE:
      return {
        ...state,
        revenueAnalytics: {
          ...state.revenueAnalytics,
          error: true,
          errorMessage: action.payload,
          fetching: false,
        },
      };

    case type.FETCH_PERFORMANCE_COMPARISON_PENDING:
      return {
        ...state,
        performanceComparison: {
          ...state.performanceComparison,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_PERFORMANCE_COMPARISON_SUCCESS:
      return {
        ...state,
        performanceComparison: {
          ...state.performanceComparison,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_PERFORMANCE_COMPARISON_FAILURE:
      return {
        ...state,
        performanceComparison: {
          data: {},
          error: true,
          errorMessage: action.payload,
          fetching: false,
          success: false,
        },
      };

    case type.FETCH_POPULAR_ITEMS_PENDING:
      return {
        ...state,
        popularItems: {
          ...state.popularItems,
          // Cleared (not just left stale) so a period change can't leave a
          // previous period's Food/Beverage/Retail data visible while the new
          // "All" response has landed but the new background fetches haven't.
          data: {},
          fetching: true,
          error: false,
          errorMessage: '',
          success: false,
        },
      };
    case type.FETCH_POPULAR_ITEMS_SUCCESS:
      return {
        ...state,
        popularItems: {
          ...state.popularItems,
          // Merged rather than replaced: "All" arrives first and renders the
          // page, then Food/Beverage/Retail merge in as they load in the background.
          data: { ...state.popularItems.data, ...action.payload },
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_POPULAR_ITEMS_FAILURE:
      return {
        ...state,
        popularItems: {
          data: {},
          error: true,
          errorMessage: action.payload,
          fetching: false,
          success: false,
        },
      };

    case type.FETCH_POPULAR_ITEMS_SUMMARY_PENDING:
      return {
        ...state,
        popularItemsSummary: {
          ...state.popularItemsSummary,
          fetching: true,
          error: false,
          errorMessage: '',
          success: false,
        },
      };
    case type.FETCH_POPULAR_ITEMS_SUMMARY_SUCCESS:
      return {
        ...state,
        popularItemsSummary: {
          ...state.popularItemsSummary,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_POPULAR_ITEMS_SUMMARY_FAILURE:
      return {
        ...state,
        popularItemsSummary: {
          data: {},
          error: true,
          errorMessage: action.payload,
          fetching: false,
          success: false,
        },
      };

    case type.FETCH_ORDER_CHANNEL_MIX_PENDING:
      return {
        ...state,
        orderChannelMix: {
          ...state.orderChannelMix,
          fetching: true,
          error: false,
          errorMessage: '',
          success: false,
        },
      };
    case type.FETCH_ORDER_CHANNEL_MIX_SUCCESS:
      return {
        ...state,
        orderChannelMix: {
          ...state.orderChannelMix,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_ORDER_CHANNEL_MIX_FAILURE:
      return {
        ...state,
        orderChannelMix: {
          data: {},
          error: true,
          errorMessage: action.payload,
          fetching: false,
          success: false,
        },
      };

    case type.FETCH_REVENUE_TREND_HOURLY_PENDING:
      return {
        ...state,
        revenueTrendHourly: {
          ...state.revenueTrendHourly,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_REVENUE_TREND_HOURLY_SUCCESS:
      return {
        ...state,
        revenueTrendHourly: {
          ...state.revenueTrendHourly,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_REVENUE_TREND_HOURLY_FAILURE:
      return {
        ...state,
        revenueTrendHourly: {
          ...state.revenueTrendHourly,
          error: true,
          errorMessage: action.payload,
          fetching: false,
        },
      };
    case type.CLEAR_REVENUE_TREND_HOURLY:
      return {
        ...state,
        revenueTrendHourly: initialState.revenueTrendHourly,
      };

    case type.FETCH_REVENUE_TREND_HOURLY_COMPARISON_PENDING:
      return {
        ...state,
        revenueTrendHourlyComparison: {
          ...state.revenueTrendHourlyComparison,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_REVENUE_TREND_HOURLY_COMPARISON_SUCCESS:
      return {
        ...state,
        revenueTrendHourlyComparison: {
          ...state.revenueTrendHourlyComparison,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_REVENUE_TREND_HOURLY_COMPARISON_FAILURE:
      return {
        ...state,
        revenueTrendHourlyComparison: {
          ...state.revenueTrendHourlyComparison,
          error: true,
          errorMessage: action.payload,
          fetching: false,
        },
      };
    case type.CLEAR_REVENUE_TREND_HOURLY_COMPARISON:
      return {
        ...state,
        revenueTrendHourlyComparison: initialState.revenueTrendHourlyComparison,
      };

    case type.FETCH_REVENUE_TREND_HOURLY_BAND_PENDING:
      return {
        ...state,
        revenueTrendHourlyBand: {
          ...state.revenueTrendHourlyBand,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_REVENUE_TREND_HOURLY_BAND_SUCCESS:
      return {
        ...state,
        revenueTrendHourlyBand: {
          ...state.revenueTrendHourlyBand,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_REVENUE_TREND_HOURLY_BAND_FAILURE:
      return {
        ...state,
        revenueTrendHourlyBand: {
          ...state.revenueTrendHourlyBand,
          error: true,
          errorMessage: action.payload,
          fetching: false,
        },
      };
    case type.CLEAR_REVENUE_TREND_HOURLY_BAND:
      return {
        ...state,
        revenueTrendHourlyBand: initialState.revenueTrendHourlyBand,
      };

    case type.FETCH_REVENUE_TREND_DAY_BAND_PENDING:
      return {
        ...state,
        revenueTrendDayBand: {
          ...state.revenueTrendDayBand,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_REVENUE_TREND_DAY_BAND_SUCCESS:
      return {
        ...state,
        revenueTrendDayBand: {
          ...state.revenueTrendDayBand,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_REVENUE_TREND_DAY_BAND_FAILURE:
      return {
        ...state,
        revenueTrendDayBand: {
          ...state.revenueTrendDayBand,
          error: true,
          errorMessage: action.payload,
          fetching: false,
        },
      };
    case type.CLEAR_REVENUE_TREND_DAY_BAND:
      return {
        ...state,
        revenueTrendDayBand: initialState.revenueTrendDayBand,
      };

    default:
      return state;
  }
};
